import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/Hotel/components/Layout/index.js